<template>
    <div class="home">
        <div id="ask-gender-dialog" v-if="showGenderDialog">
            <div>
                <md-button @click="register('her')">I am female</md-button>
                <md-button @click="register('him')">I am male</md-button>
                <p>
                    This app uses a lot of handwritten gendered text, because of
                    this for now this app only works for heterosexual couples.
                    We are sorry.
                </p>
            </div>
        </div>
        <div id="logo" ref="logo-container">
            <div class="pink"></div>
            <div class="blue"></div>
            <div class="title-line one" ref="titleLineOne">Sexier</div>
            <div class="title-line two" ref="titleLineTwo">Together</div>
        </div>
        <!-- <img src="@/assets/logost.png" /> -->
        <p class="color">
            Sex is <strong>easy</strong>. Sex is <strong>hard</strong>. Sex is
            <strong>personal</strong>. And at the end of the day communicating
            about sex can be suprisingly <strong>challenging</strong>.
        </p>
        <p class="color">
            <strong>Sexier Together</strong> is an app with a simple goal: Help
            you <strong>discover</strong> things you both would be
            <strong>open to trying</strong>, but are not comfortable starting a
            conversation about.
        </p>
        <md-button @click="askGender">Start now (no registration)</md-button>
        <p>
            <em>How it works:</em>
        </p>
        <ul>
            <li>
                When you open the app each of you is presented with a
                <strong>stack of cards</strong>. If you love the idea, swipe
                right. Not ready for it, swipe left. Open to it, but not feeling
                it? Swipe down.
            </li>
            <li>
                Twice per week a list of <strong>matches</strong> are generated.
                These will favor ideas you both <strong>love</strong>, but will
                also include ideas one or both of you are only open to. That way
                <em
                    >neither of you will know for sure how your significant
                    other voted</em
                >.
            </li>
        </ul>
    </div>
</template>
<style scoped lang="less">
@import url('../styles/text.less');
</style>
<script>
import api from '@/services/api'

export default {
    name: 'Home',
    components: {},
    data() {
        return {
            showGenderDialog: false,
        }
    },
    mounted() {
        const logo = this.$refs['logo-container'];
        const one = this.$refs['titleLineOne'];
        const two = this.$refs['titleLineTwo'];
        const logoBoundingRect = logo.getBoundingClientRect();
        const width = Math.sqrt(logoBoundingRect.height**2 + logoBoundingRect.width ** 2)
        const rad = Math.atan(-logoBoundingRect.height/logoBoundingRect.width);
        // alert(rad);
        one.style.transform = `translateY(calc((100vh - 56px - 40px))) rotate(${rad}rad) translateX(-100vh)`;
        two.style.transform = `translateY(calc((100vh - 56px))) rotate(${rad}rad) translateX(100vh)`;
        one.style.width = `${width}px`;
        two.style.width = `${width}px`;
        setTimeout(() => {
            one.style.transition = `transform .5s ease-in-out`;
            two.style.transition = `transform .5s ease-in-out`;
            one.style.transform = `translateY(calc((100vh - 56px - 40px))) rotate(${rad}rad) translateX(0vh)`;
            two.style.transform = `translateY(calc((100vh - 56px))) rotate(${rad}rad) translateX(0vh)`;
        }, 1);
        setTimeout(() => {
            one.style.transform = `translateY(calc((100vh - 56px - 40px))) rotate(${rad}rad) translateX(100vh)`;
            two.style.transform = `translateY(calc((100vh - 56px))) rotate(${rad}rad) translateX(-100vh)`;
        }, 750);
        // setTimeout(() => {
        //     one.style.transform = 'translateX(-100vw) translateY(calc((100vh - 56px - 40px))) rotate(-55.701350723899154deg) translateX(0vh)';
        //     // two.style.transform = 'translateY(calc((100vh - 56px))) rotate(${rad}rad) translateX(0vh)';
        // }, 1000);
    },
    methods: {
        askGender() {
            setTimeout(() => {
                this.showGenderDialog = true
            }, 500)
        },
        async register(who) {
            // him or her
            const dec2hex = dec => ('0' + dec.toString(16)).substr(-2)

            const generateId = len => {
                const arr = new Uint8Array((len || 40) / 2)
                window.crypto.getRandomValues(arr)
                return Array.from(arr, dec2hex).join('')
            }
            const user = {
                mail: generateId(20) + '@sexiertogether.com',
                password: generateId(20),
            }
            const partner = {
                mail: generateId(20) + '@sexiertogether.com',
                password: generateId(20),
            }
            const userAccount = await api.request(
                'post',
                'users',
                {
                    email: user.mail,
                    password: user.password,
                    isAnon: true,
                    gender: who === 'him' ? 'm' : 'f',
                    isPublic: false
                },
                false
            )

            const partnerAccount = await api.request(
                'post',
                'users',
                {
                    email: partner.mail,
                    password: partner.password,
                    isAnon: true,
                    gender: who === 'him' ? 'f' : 'm',
                    partner: 'id:' + userAccount._id,
                    isPublic: true
                },
                false
            )

            await api.login(user.mail, user.password)

            await api.request('PATCH', 'users/' + userAccount._id, {
                partner: 'id:' + partnerAccount._id,
            })

            const { accessToken } = await api.login(
                partner.mail,
                partner.password,
                false
            )

            localStorage.setItem('temporaryPartnerAccessToken', accessToken);

            console.log(accessToken)

            this.$router.push({
                path: '/rate',
            })
        },
    },
}
</script>
